export const FLEX_LAYOUT_WIDTH_BREAKPOINT = 361;

export const DESKTOP_SCREEN_WIDTH = 1281;
export const LARGE_DESKTOP_SCREEN_WIDTH = 1440;
